<template>
    <div class="mt-2">
        <v-btn x-small fab color="primary" @click=" rotate(-1)" :title="$t('Kierrä vasemmalle')">
            <v-icon size="24">{{ icons.mdiRotateLeft }}</v-icon>
        </v-btn>
        <v-btn x-small fab color="primary" class="ml-1" @click="rotate(1)" :title="$t('Kierrä oikealle')">
            <v-icon size="24">{{ icons.mdiRotateRight }}</v-icon>
        </v-btn>
        <v-btn x-small fab color="primary" class="ml-2" @click="flipX" :title="$t('Peilaa vaakasuunnassa')">
            <v-icon size="24">{{ icons.mdiSwapHorizontal }}</v-icon>
        </v-btn>
        <v-btn x-small fab color="primary" class="ml-1" @click="flipY" :title="$t('Peilaa pystysuunnassa')">
            <v-icon size="24">{{ icons.mdiSwapVertical }}</v-icon>
        </v-btn>
    </div>
</template>

<script>
import { computed } from '@vue/composition-api'
import {
    mdiRotateLeft,
    mdiRotateRight,
    mdiSwapHorizontal,
    mdiSwapVertical,
} from '@mdi/js'

export default {
    name: 'CroppaControls',
    props: {
        croppa: { type: Object, required: true },
    },
    setup(props) {

        const rotate = step => {
            const c = props.croppa
            if (!c || typeof c.rotate !== 'function') return
            c.rotate(step)
        }

        const flipX = () => {
            const c = props.croppa
            if (!c || typeof c.flipX !== 'function') return
            c.flipX()
        }

        const flipY = () => {
            const c = props.croppa
            if (!c || typeof c.flipY !== 'function') return
            c.flipY()
        }

        const icons = { mdiRotateLeft, mdiRotateRight, mdiSwapHorizontal, mdiSwapVertical }

        return { rotate, flipX, flipY, icons }
    },
}
</script>
